import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CompanyLoaderComponent } from '../loader-animations/company-loader/company-loader.component';
import { SpinnerLoaderComponent } from '../loader-animations/spinner-loader/spinner-loader.component';
@Component({
  selector: 'app-dynamic-loader',
  templateUrl: './dynamic-loader.component.html',
  styleUrls: ['./dynamic-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    SpinnerLoaderComponent,
    CompanyLoaderComponent
  ]
})
export class DynamicLoaderComponent {
  @Input() loaderType = "company-loader"
  @Input() diameter = 40;
  @Input() stroke = 3;

}


